import React from 'react';
import { NodeViewWrapper } from '@tiptap/react';
import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
function RadioGroupViewer({ node }) {
  const { id, label, options, selected } = node.attrs;

  return (
    <NodeViewWrapper
      id={id}
      data-placeholder-id={id}
      data-field-id={id}
      className="
    radio-field
    my-4
    rounded-xl
    border
    border-slate-200
    p-4
    bg-white
    space-y-3
    transition-all
    duration-300
  "
    >
      {/* LABEL */}
      {label && (
        <div
          className="text-sm  font-semibold text-slate-700   focus:outline-none
  focus:ring-2 focus:ring-[#375AE7]/20
  focus:border-[#375AE7]"
        >
          {label}
        </div>
      )}

      {/* OPTIONS */}
      <div className="space-y-2">
        {options?.map((option, index) => (
          <div key={index} className="flex items-center gap-3">
            {/* RADIO DISPLAY ONLY */}
            <div
              className={`
                h-4 w-4 rounded-full border flex items-center justify-center
                ${selected === option ? 'border-[#375AE7]' : 'border-slate-300'}
              `}
            >
              {selected === option && (
                <div className="h-2 w-2 rounded-full bg-[#375AE7]" />
              )}
            </div>

            {/* OPTION TEXT */}
            <span className="text-sm text-slate-700">{option}</span>
          </div>
        ))}
      </div>
    </NodeViewWrapper>
  );
}

export const RadioGroupViewerNode = Node.create({
  name: 'radioGroup',

  group: 'block',

  atom: true,

  addAttributes() {
    return {
      id: {
        default: null,
      },
      label: {
        default: '',
      },
      options: {
        default: [],
      },
      selected: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="radio-group"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        'data-type': 'radio-group',
      }),
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(RadioGroupViewer);
  },
});
